import React, { useEffect, useRef, useState } from "react";
import DynamicTable from "../../../unicomponents/Tables/DynamicTable";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useOrganizationSetting from "../../../hooks/useOrganizationSetting";
import useTermPeriod from "../../../hooks/useTermPeriod";
import { useAuthContext } from "../../../context/AuthContext";
import { useUIContext } from "../../../context/UIContext";
import { setTermIdByToday } from "../../../util/dateRelated";
import useLessonStudents from "../../../hooks/useLessonStudentData";
import HelpHyperLink from "../../../unicomponents/HelpHyperLink";
import DropdownSchoolYear from "../../../unicomponents/Dropdowns/DropdownSchoolYear";
import DropdownTermDate from "../../../unicomponents/Dropdowns/DropdownTermDate";
import useFlexibleData from "../../../hooks/useFlexibleData";
import SimpleAlertMessageBlock from "../../../unicomponents/SimpleAlertMessageBlock";

/* 
좋아 거의 다 했다...
1. flexibleData로 tableConfig의 행을 옵션형을 추가 삭제 할 수 있도록 하기. 기본형은 있고.
2. setExportFileName 추가.
3. 접근 권한 설정 -> 접근 설정만 함. 접근하면 다 볼 수 있음
그럼 끝인가?
*/

export default function GradeDataTable() {
  const { t } = useTranslation();
  const location = useLocation();
  const paths = location.pathname.split("/");
  const schoolId = paths[1];
  const conditions = {
    schoolid: schoolId,
    // lesson_id: 이거 나중에 추가해야 함
  };

  //   const [exportFileName, setExportFileName] = useState({schoolYear: "", schoolTerm: ""});
  const [termId, setTermId] = useState("");
  const [termName, setTermName] = useState("");
  const [lessonStudentsData, setLessonStudentsData] = useState([]);

  const [filters, setFilters] = useState({
    schoolYear: null,
    schoolYearId: "",
    hierarchyOneId: "",
    hierarchyTwoId: "",
    hierarchyThreeId: "",
    organPathForSort: "/",
    termId: "",
    selectedTeacherId: "",
    selectedLessonId: "",
    termName: "",
  });

  //그냥 findAllbySchoolYear로 학년도 기준으로 필요한 정보 모두 조인해서 다 가져오자. 가져와서 useEffect로 filter 하자.

  const {
    settingQuery: { data: settingData },
  } = useOrganizationSetting(conditions);

  const {
    termPeriodQuery: { data: termPeriodData },
  } = useTermPeriod(conditions);

  const { getAllLessonStudentsBySchoolYear } = useLessonStudents();
  const getAllLessonStudentsBySchoolYearRef = useRef(
    getAllLessonStudentsBySchoolYear
  );

  const {
    flexibleDataQuery: { data: flexibleData },
  } = useFlexibleData({
    schoolid: schoolId,
    main_category: "gradeDataTable",
  });

  const { user, hasPermission } = useAuthContext();

  const { setIsLoadingModal } = useUIContext();

  useEffect(() => {
    let initialSchoolYear = null;
    let initialSchoolYearId = null;
    // let initialUsername = null;

    if (filters.schoolYear === null && settingData && settingData.length > 0) {
      const initialData = settingData.sort(
        (a, b) => b.school_year - a.school_year
      )[0];

      initialSchoolYear = initialData.school_year;
      initialSchoolYearId = initialData.id;
      setFilters((filters) => ({
        ...filters,
        schoolYear: initialSchoolYear,
        schoolYearId: initialSchoolYearId,
      }));

      // console.log("sortedLessons", sortedLessons);

      if (termPeriodData) {
        setTermIdByToday(termPeriodData, setTermId, initialSchoolYearId);
      }
    }
  }, [filters, filters.schoolYear, settingData, termId, termPeriodData]);

  // termId가 변경될 때마다 termName 설정
  useEffect(() => {
    if (termId && termPeriodData) {
      const selectedTerm = termPeriodData.find(
        (term) => term.id.toString() === termId.toString()
      );
      setTermName(selectedTerm?.term_name || "");
      setFilters((filters) => ({
        ...filters,
        termName: selectedTerm?.term_name || "",
      }));
    } else {
      setTermName("");
    }
  }, [termId, termPeriodData]);

  useEffect(() => {
    if (user) {
      if (user.role === "teacher") {
        setFilters((filters) => ({
          ...filters,
          selectedTeacherId: user.username,
        }));
      }
    }
  }, [user]);

  useEffect(() => {
    if (filters?.schoolYearId && settingData) {
      const forWhere = {
        schoolid: schoolId,
        school_year_id: filters?.schoolYearId,
      };

      setIsLoadingModal(true);
      getAllLessonStudentsBySchoolYearRef.current.mutate(forWhere, {
        onSuccess: (data) => {
          //   console.log("data", data);
          setIsLoadingModal(false);

          if (settingData) {
            const settingMap = settingData.reduce((map, setting) => {
              map[setting.id] = setting.group_name;
              return map;
            }, {});

            const updatedData = data.map((studentData) => {
              const pathParts =
                studentData?.registration?.organization_path.split("/");
              const stageId = pathParts[2]; // 과정
              const yearId = pathParts[3]; // 학년
              const classId = pathParts[4]; // 반

              const groupNameOne = settingMap[stageId];
              const groupNameTwo = settingMap[yearId];
              const groupNameThree = settingMap[classId];

              return {
                ...studentData,
                hierarchyOne: groupNameOne,
                hierarchyTwo: groupNameTwo,
                hierarchyThree: groupNameThree,
                fullname: studentData?.student?.fullname,
                idatschool: studentData?.student?.idatschool,
                subjectName: studentData?.lesson?.subject_name,
                teachers: studentData?.lesson?.teachers
                  ?.map((teacher) => teacher.tname)
                  .join(", "),
                lessonHours: studentData?.lesson?.lesson_hours,
                termName: studentData?.lesson?.TermDates?.term_name,
                otherName: studentData?.student?.other_name,
                gender: studentData?.student?.gender,
              };
            });
            // console.log("updatedData", updatedData);

            // console.log("termName", termName);
            const filteredData = termName
              ? updatedData.filter((item) => item.termName === termName)
              : updatedData;
            // console.log("filteredData", filteredData);

            setLessonStudentsData(filteredData);
          }
        },
        onError: (error) => {
          setIsLoadingModal(false);

          console.error(error); // 일단 콘솔에 에러를 출력합니다.
          console.error("위와 같은 에러가 났으니 고치삼");
          alert(t("common.messages.errorAlert") + error.message);
        },
      });
    } else {
      setLessonStudentsData([]);
    }
  }, [
    filters?.schoolYearId,
    schoolId,
    t,
    settingData,
    termName,
    setIsLoadingModal,
  ]);

  const defaultHeaders = [
    {
      headerKey: "termName",
      label: t("common.labels.termName" || "학기"),
      style: { width: "80px" },
      sortField: "termName",
    },
    {
      headerKey: "hierarchyOne",
      label: t("common.labels.schoolStage" || "과정"),
      style: { width: "80px" },
      sortField: "hierarchyOne",
    },
    {
      headerKey: "hierarchyTwo",
      label: t("common.labels.studentYear" || "학년"),
      style: { width: "80px" },
      sortField: "hierarchyTwo",
    },
    {
      headerKey: "hierarchyThree",
      label: t("common.labels.class" || "반"),
      style: { width: "80px" },
      sortField: "hierarchyThree",
    },
    {
      headerKey: "fullname",
      label: t("common.user.fullname" || "이름"),
      style: { minWidth: "80px" },
      sortField: "fullname",
    },
    ...(flexibleData &&
    flexibleData[0]?.data_value?.columns?.includes("otherName")
      ? [
          {
            headerKey: "otherName",
            label: t("common.user.otherName" || "다른 이름"),
            style: { minWidth: "80px" },
            sortField: "otherName",
            ...(flexibleData[0]?.data_value?.customSortOrder?.otherName && {
              customSortOrder:
                flexibleData[0].data_value.customSortOrder.otherName,
            }),
          },
        ]
      : []),
    ...(flexibleData && flexibleData[0]?.data_value?.columns?.includes("gender")
      ? [
          {
            headerKey: "gender",
            label: t("common.user.gender" || "성별"),
            style: { width: "60px" },
            sortField: "gender",
            ...(flexibleData[0]?.data_value?.customSortOrder?.gender && {
              customSortOrder:
                flexibleData[0].data_value.customSortOrder.gender,
            }),
          },
        ]
      : []),
    ...(flexibleData &&
    flexibleData[0]?.data_value?.columns?.includes("username")
      ? [
          {
            headerKey: "username",
            label: t("common.user.username" || "유저네임"),
            style: { minWidth: "100px" },
            sortField: "username",
            ...(flexibleData[0]?.data_value?.customSortOrder?.username && {
              customSortOrder:
                flexibleData[0].data_value.customSortOrder.username,
            }),
          },
        ]
      : []),
    ...(flexibleData &&
    flexibleData[0]?.data_value?.columns?.includes("idatschool")
      ? [
          {
            headerKey: "idatschool",
            label: t("common.user.idatschool" || "학번"),
            style: { width: "80px" },
            sortField: "idatschool",
            ...(flexibleData[0]?.data_value?.customSortOrder?.idatschool && {
              customSortOrder:
                flexibleData[0].data_value.customSortOrder.idatschool,
            }),
          },
        ]
      : []),

    {
      headerKey: "subjectName",
      label: t("student.studentGrades.subjectName" || "과목"),
      style: { mindWidth: "200px" },
      sortField: "subjectName",
    },
    {
      headerKey: "teachers",
      label: t("student.studentGrades.teacher"),
      style: { minWidth: "100px" },
      sortField: "teachers",
    },
    ...(flexibleData &&
    flexibleData[0]?.data_value?.columns?.includes("lessonHours")
      ? [
          {
            headerKey: "lessonHours",
            label: t("student.studentGrades.lessonHours"),
            style: { width: "80px" },
            sortField: "lessonHours",
            ...(flexibleData[0]?.data_value?.customSortOrder?.lessonHours && {
              customSortOrder:
                flexibleData[0].data_value.customSortOrder.lessonHours,
            }),
          },
        ]
      : []),
    {
      headerKey: "grade",
      label: t("student.studentGrades.score"),
      style: { width: "80px" },
      sortField: "grade",
    },
    ...(flexibleData &&
    flexibleData[0]?.data_value?.columns?.includes("convert100")
      ? [
          {
            headerKey: "convert100",
            label: t("common.labels.convert100"),
            style: { width: "80px" },
            sortField: "convert100",
            ...(flexibleData[0]?.data_value?.customSortOrder?.convert100
              ? {
                  customSortOrder:
                    flexibleData[0].data_value.customSortOrder.convert100,
                }
              : {
                  customSortOrder: {
                    "A+": 1,
                    A: 2,
                    "A-": 3,
                    "B+": 4,
                    B: 5,
                    "B-": 6,
                    "C+": 7,
                    C: 8,
                    "C-": 9,
                    "D+": 10,
                    D: 11,
                    "D-": 12,
                    F: 13,
                    P: 14,
                  },
                }),
          },
        ]
      : []),
  ];

  const defaultColumns = [
    { valueKey: "termName" },
    { valueKey: "hierarchyOne" },
    { valueKey: "hierarchyTwo" },
    { valueKey: "hierarchyThree" },
    { valueKey: "fullname" },
    ...(flexibleData &&
    flexibleData[0]?.data_value?.columns?.includes("otherName")
      ? [{ valueKey: "otherName" }]
      : []),
    ...(flexibleData && flexibleData[0]?.data_value?.columns?.includes("gender")
      ? [{ valueKey: "gender", cellStyle: { textAlign: "center" } }]
      : []),
    ...(flexibleData &&
    flexibleData[0]?.data_value?.columns?.includes("username")
      ? [{ valueKey: "username" }]
      : []),
    ...(flexibleData &&
    flexibleData[0]?.data_value?.columns?.includes("idatschool")
      ? [{ valueKey: "idatschool" }]
      : []),
    { valueKey: "subjectName" },
    { valueKey: "teachers", cellStyle: { textAlign: "center" } },
    ...(flexibleData &&
    flexibleData[0]?.data_value?.columns?.includes("lessonHours")
      ? [{ valueKey: "lessonHours", cellStyle: { textAlign: "center" } }]
      : []),
    { valueKey: "grade", cellStyle: { textAlign: "center" } },
    ...(flexibleData &&
    flexibleData[0]?.data_value?.columns?.includes("convert100")
      ? [{ valueKey: "convert100", cellStyle: { textAlign: "center" } }]
      : []),
  ];

  // 테이블 설정
  const tableConfig = {
    style: { fontSize: "14px", tableLayout: "auto" }, // 폰트 크기만 커스텀
    headers: defaultHeaders,
    columns: defaultColumns,
    rows: lessonStudentsData,
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;
    if (name === "0") {
      setFilters((filters) => ({
        ...filters,
        schoolYear: selectedOptionText,
        schoolYearId: value,
        hierarchyOneId: "",
        termName: "",
      }));

      setTermIdByToday(termPeriodData, setTermId, value);
    }

    if (name === "termDate") {
      setTermId(value);
    }
  };

  if (!hasPermission(null, "can_access")) {
    return (
      <SimpleAlertMessageBlock
        message={t("common.messages.noAccessPermission")}
      />
    );
  }

  return (
    <div className="basicWidth">
      <div className="container-fluid">
        <div className="d-flex flex-wrap mb-3 mt-2 gap-3">
          <div className="col-auto me-3">
            <h3 className="fw-bold">
              {t("teacher.gradeDataTable.mainTitle")}
              <HelpHyperLink link={""} />
            </h3>
          </div>
          <div style={{ width: "95px" }} className="me-1">
            <DropdownSchoolYear
              settingData={settingData}
              handleDropdownChange={handleDropdownChange}
              schoolYearId={filters.schoolYearId}
              allYears={false}
            />
          </div>
          <div style={{ width: "95px" }} className="me-1">
            <DropdownTermDate
              termPeriodData={termPeriodData}
              handleDropdownChange={handleDropdownChange}
              termId={termId}
              schoolYearId={filters.schoolYearId}
              hierarchyOneId={filters.hierarchyOneId}
              hierarchyTwoId={filters.hierarchyTwoId}
            />
          </div>
        </div>
        <DynamicTable
          tableConfig={tableConfig}
          dataStructure="flat"
          tableStyle="cleanModern"
          // 페이지네이션 활성화
          pagination={true}
          pageSize={50} // 페이지당 5개 항목 표시
          initialPage={1} // 초기 페이지 설정
          // 정렬 활성화
          sortable={true}
          initialSortField="subject_name"
          initialSortDirection="asc"
          // 검색 기능 활성화
          searchable={true}
          searchPlaceholder={t("teacher.gradeDataTable.searchPlaceholder")}
          searchFields={[
            "fullname", // input 필드
            "subjectName",
            "teachers",
            "convert100",
          ]}
          // Excel 내보내기 기능 활성화
          exportable={true}
          exportFileName={
            filters.schoolYear + "-" + filters.termName + "-GradeDataTable"
          }
          exportButtonLabel="Excel"
          // 행 클릭 기능 활성화
          // onRowClick={handleRowClick}
          // rowClickable={true}
          // selectedRowId={selectedRowId}
          // setSelectedRowId={setSelectedRowId}
          // filter 기능 활성화
          filterable={true}
          filterableColumns={[
            "hierarchyOne",
            "hierarchyTwo",
            "hierarchyThree",
            "fullname",
            "subjectName",
            "teachers",
            "convert100",
          ]}
          rowNumber={true}
        />
      </div>
    </div>
  );
}
